<section class="container py-4">
    <div class="row">
        <div class="col-md-12">
            <ul id="tabsJustified" class="nav nav-tabs iris-gst-display-flex">
                <li class="nav-item">
                    <a href="" data-target="#addBusiness" data-toggle="tab" class="nav-link " data-toggle="tab"
                        class="nav-link " [ngClass]="activeStep1 ? 'active': ''" (click)="OpenForm('step1')">User
                        Profile</a></li>
                <li class="nav-item"><a href="" data-target="#subscribe" data-toggle="tab" class="nav-link "
                        [ngClass]="activeStep2 ? 'active': ''" (click)="OpenForm('step2')">Change Password</a></li>

            </ul>
            <br>
            <div id="tabsJustifiedContent" class="tab-content card">
                <div id="addBusiness" class="tab-pane fade " [ngClass]="activeStep1 ? 'active show': ''"
                    *ngIf="activeStep1">
                    <div class="row pb-2">
                        <form id="example-form" class="col-md-12" [formGroup]="updateProfileForm"
                            *ngIf="userEmail != null">
                            <div class="form-group">
                                <label>First Name <sup>*</sup></label>
                                <input type="text" class="form-control col-md-8" formControlName="username"
                                    placeholder="Enter First Name"
                                    [ngClass]="{ 'has-danger': isSubmitted && updateProfileForm.get('username').errors }">
                                <div *ngIf="isSubmittedProfile">
                                    <span class="text-danger"
                                        *ngIf="!updateProfileForm.get('username').dirty && updateProfileForm.get('username').errors?.required">Please
                                        enter First Name
                                    </span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Middle Name </label>
                                <input type="text" class="form-control col-md-8" formControlName="middlename"
                                    placeholder="Enter Middle Name">

                            </div>
                            <div class="form-group">
                                <label>Surname <sup>*</sup></label>
                                <input type="text" class="form-control col-md-8" formControlName="lastname"
                                    placeholder="Enter Surname"
                                    [ngClass]="{ 'has-danger': isSubmitted && updateProfileForm.get('lastname').errors }">
                                <div *ngIf="isSubmittedProfile">
                                    <span class="text-danger"
                                        *ngIf="!updateProfileForm.get('lastname').dirty && updateProfileForm.get('lastname').errors?.required">Please
                                        enter Last Name
                                    </span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="pan">Mobile Number <sup>*</sup> </label>
                                <input type="text" class="form-control col-md-8" placeholder="Enter Mobile Number"
                                    formControlName="phonenumer">
                                <div *ngIf="isSubmittedProfile">
                                    <span class="text-danger"
                                        *ngIf="!updateProfileForm.get('phonenumer').dirty && updateProfileForm.get('phonenumer').errors?.required">Please
                                        enter Mobile Number
                                    </span>
                                    <span class="text-danger"
                                        *ngIf="updateProfileForm.get('phonenumer').dirty && updateProfileForm.get('phonenumer').errors">Please
                                        enter valid Mobile Number
                                    </span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="pan">Email Id<sup>*</sup> </label>
                                <input type="text" class="form-control col-md-8" placeholder="Enter Email Id"
                                    formControlName="email" readonly>
                                <div *ngIf="isSubmittedProfile">
                                    <span class="text-danger"
                                        *ngIf="!updateProfileForm.get('email').dirty && updateProfileForm.get('email').errors?.required">Please
                                        enter Email Id
                                    </span>
                                    <span class="text-danger"
                                        *ngIf="updateProfileForm.get('email').dirty && updateProfileForm.get('email').errors">Please
                                        enter valid Email Id
                                    </span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Notification Email Id<sup>*</sup> </label>
                                <input type="text" class="form-control col-md-8"
                                    placeholder="Enter Notification Email Id" formControlName="notificationEmail">
                                <div *ngIf="isSubmittedProfile">
                                    <span class="text-danger"
                                        *ngIf="!updateProfileForm.get('notificationEmail').dirty && updateProfileForm.get('notificationEmail').errors?.required">Please
                                        enter Notification Email Id
                                    </span>
                                    <span class="text-danger"
                                        *ngIf="updateProfileForm.get('notificationEmail').dirty && updateProfileForm.get('notificationEmail').errors">Please
                                        enter valid Notification Email Id
                                    </span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Aadhaar Number</label>
                                <input type="text" class="form-control col-md-8" placeholder="Enter Aadhaar Number"
                                    formControlName="aadhaar">
                                <div *ngIf="isSubmittedProfile">
                                    <span class="text-danger"
                                        *ngIf="updateProfileForm.get('aadhaar').dirty && updateProfileForm.get('aadhaar').errors">Aadhaar
                                        number should be numeric and 12 digit, Never starts with 0 & 1.
                                    </span>
                                </div>
                            </div>

                        </form>
                    </div>
                    <button type="submit" class="btn btn-primary" (click)="updateProfile()">Submit</button>
                    <button class="btn btn-light ml-1" (click)="toDashboard()">Back</button>
                </div>
                <div id="subscribe" class="tab-pane fade">
                    <div class="row pb-2">
                        <form class="col-md-12" [formGroup]="updatePassForm">
                            <div class="form-group">
                                <label for="companyname">Current Password <sup>*</sup></label>
                                <input type="password" class="form-control col-md-8 " formControlName="curentpassword"
                                    placeholder="Current Password">
                                <div *ngIf="isSubmitted && f.curentpassword.errors">
                                    <span class="text-danger" *ngIf="f.curentpassword.errors.required">Current Password
                                        Required
                                    </span>
                                    <span class="text-danger"
                                        *ngIf="!f.curentpassword.errors.required && f.curentpassword.errors">Invalid
                                        Current
                                        Password
                                    </span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="companyname">New Password <sup>*</sup></label>
                                <input type="password" class="form-control col-md-8 " formControlName="newpassword"
                                    placeholder="New Password">
                                <div *ngIf="isSubmitted && f.newpassword.errors">
                                    <span class="text-danger" *ngIf="f.newpassword.errors.required">New Password
                                        Required
                                    </span>
                                    <span class="text-danger"
                                        *ngIf="!f.newpassword.errors.required && f.newpassword.errors">Invalid New
                                        Password
                                    </span>
                                </div>
                                <div class="col-md-8 clrOrange"><p class="noteText"><i class="fa fa-info-circle"></i> Password must be of min 8 and max 16 characters in length consisting of at least 1 capital and 1 small letter, 1 number and 1 special character. The special characters allowed are @ # $ % ^ & + = . [ ] * ?</p></div>
                            </div>
                            <div class="form-group">
                                <label for="companyname">Confirm Password <sup>*</sup></label>
                                <input type="password" class="form-control col-md-8 " formControlName="confirmpassword"
                                    placeholder="Confirm Password">
                                <div *ngIf="isSubmitted && f.confirmpassword.errors">
                                    <span class="text-danger" *ngIf="f.confirmpassword.errors.required">Confirm Password
                                        Required
                                    </span>
                                </div>
                            </div>
                        </form>
                    </div>
                    <button type="submit" class="btn btn-primary" (click)="updatePassword()">Finish</button>
                    <button class="btn btn-light ml-1" (click)="toDashboard()">Back</button>
                </div>
            </div>
        </div>
    </div>
</section>
